import Container from "@mui/material/Container";
import Navbar from "../../component/navbar/Navbar";
import {ReactNode, useEffect, useMemo} from "react";
import ScrollTopContainer from "../../component/shared/scroll-top-container/ScrollTopContainer";
import Footer from "../footer/Footer";
import {RootState, useAppDispatch, useAppSelector} from "../../store";
import SomethingWentWrong from "./something-went-wrong/SomethingWentWrong";
import NotFound from "./not-found/NotFound";
import {setApplicationError} from "../../store/app/Slice";
import SocialMedia from "./social-media/SocialMedia";
import {useMediaQuery} from "@mui/material";
import {useLocation} from "react-router-dom";

interface Props {
    children: ReactNode
}

const DefaultLayout = (props: Props) => {
    const error = useAppSelector((state: RootState) => state.appReducer.error)
    const errorCode = useAppSelector((state: RootState) => state.appReducer.errorCode)
    const dispatch = useAppDispatch()
    const matches = useMediaQuery('(min-width:1350px)');
    const {pathname} = useLocation()


    useEffect(() => {
        return () => {
            if (error) {
                dispatch(setApplicationError({isError: false, statusCode: undefined}))
            }
        }
    }, [dispatch, error, pathname])

    const renderContent = useMemo(() => {
        if (error) {
            if (errorCode === 404) {
                return <NotFound/>
            }
            return <SomethingWentWrong/>
        }
        return props.children
    }, [error, errorCode, props.children])


    return (
        <ScrollTopContainer>
            <>
                {matches ? <SocialMedia/> : null}
                <Navbar/>
                <Container component="main" maxWidth="lg"
                           sx={{mt: '6em', display: 'flex', flexDirection: 'column', flexGrow: 1}}>
                    {renderContent}
                </Container>
                <Footer/>
            </>
        </ScrollTopContainer>


    )
}
export default DefaultLayout
